export const ActionTypes = {
  FETCH_ALL: 'services/rejection_reason/fetch_all',
  SET_LOADER_STATUS: 'services/rejection_reason/set_loader_status',
  SET_ALL: 'services/rejection_reason/set_all',
  FETCH_ALL_REJECTION_REASONS: 'services/rejection_reason/fetch_all_rejection_reasons',
  SET_ALL_REJECTION_REASONS: 'services/rejection_reason/set_all_rejection_reasons',
  ADD_OR_UPDATE_REJECTION_REASON: 'services/rejection_reason/add_or_update_rejection_reason',
  DELETE_REJECTION_REASON: 'services/rejection_reason/delete_rejection_reason',
  CHANGE_IS_PRIORITY_REJECTION_REASON: 'services/rejection_reason/change_is_priority_rejection_reason',
  CAN_ADD_IS_PRIORITY_REJECTION_REASON: 'services/rejection_reason/can_add_is_priority_rejection_reason',
  SET_CAN_ADD_IS_PRIORITY_REJECTION_REASON: 'services/rejection_reason/set_can_add_is_priority_rejection_reason',
  SET_IS_LOADING_CAN_ADD_PRIORITY: 'services/rejection_reason/set_loading_can_add_is_priority',
};
const fetchAll = ({ rejectionReasonParams }) => ({
  rejectionReasonParams,
  type: ActionTypes.FETCH_ALL,
});

const setLoader = ({ showLoader }) => ({
  showLoader,
  type: ActionTypes.SET_LOADER_STATUS,
});

const setAll = ({ allRejectionReasons }) => ({
  allRejectionReasons,
  type: ActionTypes.SET_ALL,
});

const fetchAllRejectionReasons = () => ({
  type: ActionTypes.FETCH_ALL_REJECTION_REASONS,
});

const setAllRejectionReasons = ({ allRejectionReasonsData }) => ({
  allRejectionReasonsData,
  type: ActionTypes.SET_ALL_REJECTION_REASONS,
});

const addOrUpdateRejectionReason = ({ rejectionReasonData, actionName, rejectionReasonParams }) => ({
  rejectionReasonData,
  actionName,
  rejectionReasonParams,
  type: ActionTypes.ADD_OR_UPDATE_REJECTION_REASON,
});

const deleteRejectionReason = data => ({
  ...data,
  type: ActionTypes.DELETE_REJECTION_REASON,
});
const changeIsPriority = data => ({
  ...data,
  type: ActionTypes.CHANGE_IS_PRIORITY_REJECTION_REASON,
});
const canAddIsPriority = id => ({
  id,
  type: ActionTypes.CAN_ADD_IS_PRIORITY_REJECTION_REASON,
});
const setCanAddIsPriority = ({ canAddIsPriority }) => ({
  canAddIsPriority,
  type: ActionTypes.SET_CAN_ADD_IS_PRIORITY_REJECTION_REASON,
});
const setIsLoadingCanAddPriority = ({ isLoadingCanAddPriority }) => ({
  isLoadingCanAddPriority,
  type: ActionTypes.SET_IS_LOADING_CAN_ADD_PRIORITY,
});
export default {
  fetchAll,
  setLoader,
  setAll,
  fetchAllRejectionReasons,
  setAllRejectionReasons,
  addOrUpdateRejectionReason,
  deleteRejectionReason,
  changeIsPriority,
  canAddIsPriority,
  setCanAddIsPriority,
  setIsLoadingCanAddPriority,
};
